import React, { useEffect, useState } from 'react'
import { Header } from '../../../components/header/Header'
import { useFormik } from 'formik';
import { CiImageOn } from "react-icons/ci";
import editIcon from "../../../assets/edit_icon.png";
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { Spinner } from '../../../components/spinner/Spinner';
import toast from 'react-hot-toast';
import { addRewardThunk, getRewardDetailsThunk } from '../../../slices/rewards/thunk';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

export default function CreateReward() {
  const navigate = useNavigate();
  const [qrPreview, setQrPreview] = useState(null);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const [isShowSpinner1, setIsShowSpinner1] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isFetchingReward, setIsFetchingReward] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams(); // Get encrypted ID from URL params

  const selectUserState = (state) => state.user;
  const userProperties = createSelector(selectUserState, (user) => ({
    isSuccess: user.isSuccess,
    isLoading: user.isLoading,
  }));
  const { isLoading, isSuccess } = useSelector(userProperties);
  const fileUrl = process.env.REACT_APP_FILE_URL;

  const formik = useFormik({
    initialValues: {
      reward_type: "amount",
      amount: "",
      gift_card_number: "",
      gift_card_qr_code: null,
    },
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("reward_type", values.reward_type);
      
      if (values.reward_type === "amount") {
        formData.append("amount", values.amount);
      } else {
        formData.append("gift_card_number", values.gift_card_number);
        if (values.gift_card_qr_code !== null) {
          formData.append("gift_card_qr_code", values.gift_card_qr_code);
        }
      }

      // If editing, send the encrypted ID, otherwise send 0
      formData.append("id", isEditMode ? id : 0);

      // console.log("Form Data to be submitted:");
      for (let pair of formData.entries()) {
        // console.log(pair[0] + ": " + pair[1]);
      }
      setIsShowSpinner(true);

      // Call appropriate thunk based on mode
      if (isEditMode) {
        dispatch(addRewardThunk(formData))
          .unwrap()
          .then(() => {
            toast.success('Reward updated successfully');
            formik.resetForm();
            setQrPreview(null);
            navigate(-1);
          })
          .catch((error) => {
            toast.error(error?.message || 'Failed to update reward');
          })
          .finally(() => {
            setIsShowSpinner(false);
          });
      } else {
        dispatch(addRewardThunk(formData))
          .unwrap()
          .then(() => {
            toast.success('Reward created successfully');
            formik.resetForm();
            setQrPreview(null);
            navigate(-1);
          })
          .catch((error) => {
            toast.error(error?.message || 'Failed to create reward');
          })
          .finally(() => {
            setIsShowSpinner(false);
          });
      }
    },
  });

  // Fetch reward details if in edit mode
  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      fetchRewardDetails(id);
    }
  }, [id]);

  // Function to fetch reward details using your Redux thunk
  const fetchRewardDetails = async (encryptedId) => {
    setIsFetchingReward(true);
    try {
      var result = await dispatch(getRewardDetailsThunk({ id: encryptedId })).unwrap();

      // Adjust these field names based on your API response structure
      var rewardData = result.data[0];

      // Populate form with fetched data
      formik.setValues({
        reward_type: rewardData.reward_type || "amount",
        amount: rewardData.amount || "",
        gift_card_number: rewardData.gift_card_number || "",
        gift_card_qr_code: null,
      });

      // Set QR code preview if exists
      if (rewardData.gift_card_qr_code) {
        var path = `${fileUrl}/${rewardData.gift_card_qr_code}`;
        setQrPreview(path);
      }
    } catch (error) {
      toast.error(error?.message || 'Failed to load reward details');
    } finally {
      setIsFetchingReward(false);
    }
  };

  const deleteReward = () => {
    // var data = {
    //   id: id
    // };
    // setIsShowSpinner1(true);
    // dispatch(delRewardThunk(data))
    //   .unwrap()
    //   .then((res) => {
    //     toast.success('Reward deleted successfully');
    //     navigate(-1);
    //   })
    //   .catch((error) => {
    //     toast.error(error?.message || 'Failed to delete reward');
    //   })
    //   .finally(() => {
    //     setIsShowSpinner1(false);
    //   });
  };

  // Handle QR Code Upload
  const handleQrCodeChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue("gift_card_qr_code", file);
      setQrPreview(URL.createObjectURL(file));
    }
  };

  // Spinner toggle
  useEffect(() => {
    setIsShowSpinner(isLoading || isFetchingReward);
  }, [isLoading, isFetchingReward]);

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
        <Header title={isEditMode ? "Edit Reward" : "Add Reward"} showBack={true} />
      </header>

      <div className="w-full mx-auto">
        {isFetchingReward ? (
          <div className="w-full flex items-center justify-center py-20">
            <Spinner />
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit} className="w-full">
            <div className="w-full mt-5 border border-border_color p-3 sm:py-5 sm:px-[26px] rounded-[14px]">

              {/* Reward Type Selection */}
              <div className="w-full mb-6">
                <label htmlFor="reward_type" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                  Reward Type
                </label>
                <select
                  id="reward_type"
                  name="reward_type"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.reward_type}
                  className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                >
                  <option value="amount">Amount</option>
                  <option value="gift_card">Gift Card</option>
                </select>
                {formik.errors.reward_type && formik.touched.reward_type && (
                  <p className="text-red-500 text-sm">{formik.errors.reward_type}</p>
                )}
              </div>

              {/* Amount Type Fields */}
              {formik.values.reward_type === "amount" && (
                <div className="w-full mb-6">
                  <label htmlFor="amount" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                    Amount ($)
                  </label>
                  <input
                    id="amount"
                    name="amount"
                    type="number"
                    min="0"
                 
                    placeholder="Enter amount"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.amount}
                    className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                  {formik.errors.amount && formik.touched.amount && (
                    <p className="text-red-500 text-sm">{formik.errors.amount}</p>
                  )}
                </div>
              )}

              {/* Gift Card Type Fields */}
              {formik.values.reward_type === "gift_card" && (
                <>
                  {/* Gift Card Number */}
                  <div className="w-full mb-6">
                    <label htmlFor="gift_card_number" className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                      Gift Card Number
                    </label>
                    <input
                      id="gift_card_number"
                      name="gift_card_number"
                      type="text"
                      placeholder="Enter gift card number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gift_card_number}
                      className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                    />
                    {formik.errors.gift_card_number && formik.touched.gift_card_number && (
                      <p className="text-red-500 text-sm">{formik.errors.gift_card_number}</p>
                    )}
                  </div>

                  {/* QR Code Upload */}
                  <div className="w-full mb-6">
                    <label className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
                      Gift Card QR Code
                    </label>
                    <div className="w-full flex flex-col xs:flex-row items-center justify-center">
                      <div className="w-[128px] h-[128px] border border-secondary rounded-lg p-2 flex items-center justify-center">
                        <div className="relative w-[117px] h-[117px]">
                          <div className="w-full h-full rounded-lg bg-white overflow-hidden flex items-center justify-center">
                            {qrPreview ? (
                              <img
                                src={qrPreview}
                                alt="QR Code"
                                className="w-full h-full object-cover object-center"
                              />
                            ) : (
                              <span className="text-gray-500">
                                <CiImageOn className="text-8xl text-gray-300" />
                              </span>
                            )}
                          </div>
                          <input
                            type="file"
                            id="qrCodeUpload"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={handleQrCodeChange}
                            className="hidden"
                          />
                          <label
                            htmlFor="qrCodeUpload"
                            className="absolute bottom-0 right-0 rounded-full cursor-pointer"
                          >
                            <div className="w-[30px] h-[30px]">
                              <img
                                src={editIcon}
                                alt="edit"
                                className="w-full h-full object-cover"
                              />
                            </div>
                          </label>
                        </div>
                      </div>
                      {formik.errors.gift_card_qr_code && formik.touched.gift_card_qr_code && (
                        <p className="text-red-500 text-sm">{formik.errors.gift_card_qr_code}</p>
                      )}
                    </div>
                  </div>
                </>
              )}

              {/* Submit */}
              <div className="w-full flex items-center justify-end mt-4 gap-2">
                <button type="submit" className="flex items-center bg-primary text-white py-3 px-5 rounded-[10px] gap-1">
                  {isShowSpinner ? <Spinner /> : isEditMode ? "Update" : "Create"}
                </button>
                {/* {isEditMode && (
                  <button type='button' onClick={() => deleteReward()} className="flex items-center bg-red-500 text-white py-3 px-5 rounded-[10px] gap-1">
                    {isShowSpinner1 ? <Spinner /> : "Delete"}
                  </button>
                )} */}
              </div>
            </div>
          </form>
        )}
      </div>
    </>
  )
}